// extracted by mini-css-extract-plugin
module.exports = {"header":"GlobalHeader__header--overlay--xUf1V","divider":"GlobalHeader__divider--overlay--2wPr2"};
    if(module.hot) {
      // 1571674778933
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  